import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "key"
}
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.hasViewingKey)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Your Viewing Key is: " + _toDisplayString(_ctx.viewingKey), 1))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          disabled: _ctx.loading,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createViewingKey && _ctx.createViewingKey(...args)))
        }, "Create Viewing Key", 8, _hoisted_2))
  ]))
}